export default {
  // Common
  catalog: "Katalog",
  login: "Kirish",
  all_courses: "Barcha kurslar",
  hand_shake: `Hamkorlarimiz safiga qo'shiling, referal dasturida ro'yxatdan o'ting.
Ro'yxatdan o'tishingiz bilan sizga reklama kodlari va havolalar taqdim etiladi.`,

  // Home page translations
  home_hero_title: "O'qing, rivojlaning va yangi",
  home_hero_title_2: "marralarni zabt eting",
  home_hero_login_message: "Kurslarni ko'rish uchun tizimga kiring",

  // Advantages
  advantage_1:
    "Xodimlar rivojlanishi uchun eng kerakli bilimlar yagona platformada",
  advantage_2: "Doimiy malaka oshirish va professional o'sish imkoniyati",
  advantage_3: "Shaxsiy rivojlanish rejasi va o'quv materiallari",

  // Courses section
  courses_greeting: "Assalomu alaykum, o'zingizga yoqqan kursni tanlang",
  certificated_courses: "Sertifikatlanadigan kurslar",
  certificated_courses_description:
    "Sertifikatlanadigan kurslar kichik kurslardan tashkil topkan. Ushbu oliy sertifikat siz ma'lum bir soha bo'yicha professional darajadagi bilimlarni egallaganingizni tasdiqlaydi.",
  certificated_courses_empty: "Sertifikatlanadigan kurslar mavjud emas!",
  courses_count: "ta kurs ichiga oladi",

  // Status labels
  status_progress: "Jarayonda",
  status_finished: "Bajarildi",
  status_new: "Yangi",
  course_downloading: "Kurs yuklanmoqda",
  read: "O'qish",
  status_downloading: "Kurs yuklanmoqda",

  // Partnership
  partnership_title: "Hamkorlik taklifi",
  join: "Qo'shiling",

  // News section
  news: "Yangiliklar",
  news_description:
    "Yangiliklar bo'limida bizning kurslarimiz haqida ko'proq bilib olishingiz mumkin. Ta'lim va ilmiy yangiliklar va maqolalar uchun har kuni yangiliklardan xabardor bo'ling. Aristotel veb-saytidan chiqmasdan bizni kuzatib boring.",
  all_news: "Barcha yangiliklar",

  // Auth pages
  phone_or_login_placeholder: "Telefon raqamingizni yoki login kiriting",
  phone_required: "Telefon raqamingizni kiriting yoki tizimga kiring",
  password: "Parol",
  password_required: "Parolni kiriting",
  forgot_password: "Parolni unutdingizmi?",
  confirmation_code_sent: "Tasdiqlash kodi {phone} ushbu raqamga yuborildi",
  enter_confirmation_code: "Tasdiqlovchi kodni kiriting",
  enter_another_number: "Boshqa raqamni kiritish",
  enter_phone_number: "Telefon raqamingizni kiriting",

  // User Menu
  interests: "Meni qiziqtirgan kurslar",
  exit: "Chiqish",

  // Popups
  delete: "O'chirish",
  cancel: "Bekor qilish",
  want_to_logout: "Hisobingizdan chiqishni xohlaysizmi?",
  stay_on_page: "Sahifada qolish",
  leave_feedback: "Fikr-mulohaza qoldiring",
  rate_course: "Kursni baholang",
  submit: "Jo'natish",

  // Cart
  cart: "Savatcha",
  som: "So'm",
  total_value: "Umumiy qiymati:",
  cart_empty: "Savatchangiz bo'sh",
  to_purchase: "Sotib olish uchun tizimga kiring",

  // Contact Page
  contact_for: "Aloqa uchun",
  your_message: "Sizning xabaringiz",
  name_required: "Ismingizni kiriting",
  email_required: "E-mail kiriting",
  email_invalid: "E-mail to'g'ri kiriting",
  message_required: "Xabarigizni kiriting",
  your_name: "Ismingiz",
  your_email: "Sizning e-mail",
  message_text: "Xabar matni.....",
  leave_review_placeholder: "Izoh qoldiring.....",

  // Registration
  enter_phone: "Telefon raqamingizni kiriting",
  enter_your_phone: "O'zingizni telefon raqamini kiriting.",
  enter_password: "Parolni kiriting",
  accept_terms:
    "Shaxsiy ma'lumotlarni qayta ishlash shartlari va roziligini qabul qilaman",
  register: "Ro'yxatdan o'tish",
  have_account: "Mening akkauntim bor",

  // Course Page
  course: "kurs",
  course_categories: "Kurs kategoriyalari",
  more_courses: "Ko'proq kurslar",

  // User Profile
  profile: "Profil",
  personal_info: "Shaxsiy ma`lumotlar",
  first_name: "Ismingiz",
  first_name_required: "Ismingizni kiriting",
  first_name_placeholder: "Ismingiz",
  last_name: "Otangizning ismi",
  last_name_required: "Otangizning ismini kiriting",
  last_name_placeholder: "Otangizning ismi",
  full_name: "Familiya",
  full_name_required: "Familiyangizni kiriting",
  full_name_placeholder: "Familiya",
  birth_date: "Tug'ilgan sana",
  birth_date_placeholder: "Tug'ilgan sana",
  phone: "Telefon raqami",
  phone_required_input: "Telefon raqamingizni kiriting",
  city: "Shahar",
  city_required: "Shaharni kiriting",
  city_placeholder: "Shahringiz",
  branch: "Fillial",
  branch_placeholder: "Fillialni tanlang",
  branch_required: "Fillialni tanlang",
  position: "Lavozim",
  position_placeholder: "Lavozimingiz",
  reserve: "Rezerv",
  reserve_yes: "Ha",
  reserve_no: "Yo'q",
  change_password: "Parolni o`zgartirish",
  old_password_placeholder: "Eski parolni kiriting",
  new_password_placeholder: "Yangi parol",
  repeat_password_placeholder: "Yangi parolni takrorlang",
  password_min_length: "Parol kamida {min}xonali bo'lishi kerak.",
  verify: "Tekshirish",
  confirm: "Tasdiqlash",

  // User Dashboard
  my_courses: "Mening kurslarim",
  purchased_courses: "Siz sotib olgan kurslar",
  studying_courses: "O`qiyotgan kurslaringiz",
  completed_courses: "Bitirgan kurslaringiz",
  certificates: "Sertifikatlar",
  no_courses_started: "Hozircha biron bir kursni boshlamadingiz!",
  wishlist: "Meni qiziqtirgan kurslar",
  no_wishlist: "Hech qanday kurs ro'yxati topilmadi",
  my_certificates: "Meni sertifikatlarim",
  bonuses: "Bonuslar",

  // Promo codes
  promo_codes: "Promo kodlari",
  enter_promo_code: "Promo kodni kiriting",
  promo_code_length_error: "Kod uzunligi qisqa yoki juda uzun",
  enter: "Kiriting",

  // Notifications
  notifications: "Xabarnoma",
  no_notifications: "Xabarlar yo'q",

  // Cards
  my_cards: "Karta raqamlarim",
  add_new_card: "Yangi karta qo'shish",
  card_number: "Kartangiz raqamini kiritish",
  card_number_error: "To'g'ri karta raqamini kiriting",
  card_expiry: "Kartaning amal qilish muddatini kiriting",
  card_expiry_error: "Kartaning amal qilish muddatini to'g'ri kiriting",
  enter_code: "Kodni kiriting",
  code_error: "To'g'ri kodni kiriting",

  // Invite Friends
  invite_friends: "Do'stingizni taklif qilish",
  copy_referral_code: "Yo`naltiruvchi kodni bosib, kopiya qilib oling",
  for_website: "Sayt uchun",
  for_mobile: "Mobil qurilmalari uchun",
  how_to_earn_bonus: "Bonus olish uchun nima qilish kerak",
  step_1: "Kopiya qilib olgan havolani do`stingizga yuboring",
  step_2: "Do`stingiz ro`yxatdan o`tishi kerak bo`ladi",
  step_3: "Do`stingiz biror bir kursimizni sotib olishi kerak",

  // Contact
  contact: "Aloqa",

  // Lesson Layout
  share: "Ulashish",
  course_content: "Kurs tarkibi",
  final_test: "Oraliq test",

  // Course Single
  lessons: "ta dars",
  lessons_upper: "DARSLAR",
  lessons_header: "Darslar",
  share_opinion: "Ulashish",
  course_includes: "Ushbu kurs quyidagilarni o'z ichiga oladi",
  you_may_also_like: "Sizni qiziqtirishi mumkin bo'lgan kurslar",
  save: "Saqlash",
  saved: "Saqlandi",
  course_materials: "Kurs materiallari",

  // Certified Courses
  need_complete_all_courses:
    "Asosiy sertifikat olish uchun, siz barcha kurslarni tugatishingiz kerak. Test hozircha yopiq.",
  courses_completed_take_test:
    "Barcha kurslar tugallandi! Endi siz sertifikat testini topshirishingiz mumkin.",
  test_passed_successfully:
    "Siz sertifikat sinovidan muvaffaqiyatli o'tdingiz.",
  test_passed: "Testdan o`tdingiz",
  test_not_created: "Ushbu kurs uchun test hali yaratilmagan.",
  course_loading: "Kurs yuklanmoqda...",
  in_progress: "Ishlanmoqda",
  certificate_description:
    "Sertifikatlanadigan kurs tarkibidagi kichik kurslarning barchasini muvaffaqiyatli yakunlaganingizdan so'ng yakuniy maxsus testdan o'tishingiz lozim. Yakuniy testni ham muvaffaqiyatli topshira olganingizdan so'ng maxsus yuqori sertifikatga ega bo'lasiz. Sertifikatni \"Mening sertifikatlarim\" bo'limida yuklab olishingiz mumkin.",
  attestation: "Attestatsiya",
  attestation_description:
    "Attestatsiya testlari. Testdan o'ting va sertifikat oling.",
  attestation_empty: "Hozircha attestatsiyalar yo'q",
  attestation_no_quiz: "Test hali tayyor emas",
  passed: "Topshirilgan",
  not_passed: "Topshirilmagan",
  your_score: "Natijangiz",
  retake: "Qayta topshirish",
  attestation_one_attempt:
    "Testni faqat bir marta topshirish mumkin. Vaqt test ochilishi bilan boshlanadi.",
  attestation_result_passed: "Test sinovidan o'tdi",
  attestation_result_conditional: "Test sinovidan shartli ravishda o'tdi",
  attestation_result_failed: "Test sinovidan o'tmadi",
  test_language: "Test tili",
  attestation_not_started: "Topshirilmagan",
  attestation_questions: "Savollar: {n} ta",
  attestation_minutes: "Vaqt: {n} daqiqa",
  start_test: "Testni boshlash",

  // Footer
  address:
    "Oʻzbekiston, Fargʻona viloyati, Qoʻqon shahri, Shohruxobod ko'chasi",

  // Navigation
  news_and_discounts: "Yangiliklar va chegirmalar",
  back_to_courses: "Barcha kurslar",

  // Footer
  instructions: "Ko'rsatmalar",

  // Course page
  all_courses_link: "Barcha kurslar",
  course_lessons: "Darslar",
  description: "Tavsif",
  author: "Muallif:",
  last_update: "Oxirgi yangilanish:",
  subscribers_count: "Obunachilar soni:",
  leave_comment: "Izoh qoldirish",
  details: "Batafsil",

  // Lesson page
  next: "Keyingi",
  to_test: "Testga",
  to_final_test: "Asosiy testga",
  ready: "Tayyor",
  next_lesson: "keyingi dars",
  passed_test: "Testdan o`tdingiz",
  congratulations: "Tabriklaymiz!",
  course_completed: "Siz kursni muvaffaqiyatli tamomladingiz!",
  certificate_received: "Sertifikat olindi!",
  certificate_notification:
    "Siz kursni muvaffaqiyatli tugatganingiz munosabati bilan sertifikat bilan taqdirlandingiz.",
  go_to_profile: "Profilga o'tish",
  view_certificate: "Sertifikatni ko'rish",

  // Certificate page
  my_certificates_desc:
    "Barcha bitirgan kurslaringizning sertifikatlari ushbu sahifada paydo bo`ladi.",

  // Bonus page
  bonus: "Bonus",
  withdraw: "Chiqarib olish",

  // News page
  last_news_update: "Oxirgi yangilanish:",
  today: "bugun",
  days_ago: "kun oldin",

  // Course page additional
  average_rating: "O'rtacha reyting",
  no_reviews: "Ushbu kurs haqida izoh yo`q.",
  more_reviews: "ko'proq izohlar",
  unlimited_access: "Cheksiz foydalanish",
  certificate: "Sertifikat",
  go_to_course: "Kursga o'tish",

  // 404 page
  page_not_found: "sahifa topilmadi",
  back: "oldin",
  go_to_main: "Asosiysi",

  // Checkout page (Cart2)
  checkout_title: "BUYURTMANI RASMIYLASHTIRISH",
  payment: "To'lov",
  card_payment: "Karta orqali to'lov",
  wallet_payment: "Hamyoningizdan to'lang",
  select_card_for_payment: "To'lov uchun kartani tanlang",
  no_card_add_prompt: "Sizda xarita yo'q. Kartani qo'shish uchun bosing",
  pay: "to'lash",

  // Certificate check page
  certificate_info: "Qabul qilingan sertifikat haqida ma'lumot",
  no_certificate_info_found: "Hech qanday sertifikat ma'lumoti topilmadi",
  confirmed: "Tasdiqlandi!",
  certificate_confirmation_text:
    '"Universalbank Akademiyasi" onlayn platformasi {user_name} {date} sanada {course_name} sertifikatlanadigan kursini muvaffaqiyatli yakunlagani hamda ushbu sertifikat haqiqiy ekanini tasdiqlaydi!',
  certificate_confirmation_mini_text:
    '"Universalbank Akademiyasi" onlayn platformasi {user_name} {date} sanada {course_name} mini-kursini muvaffaqiyatli yakunlagani hamda ushbu tasdiqnoma haqiqiy ekanini tasdiqlaydi!',
  view_certificate_link: "Sertifikatni ko'ring",

  // Auth placeholders
  password_placeholder: "Parol",
  enter_code_placeholder: "Kodni kiriting",
  repeat_password_input_placeholder: "Parolni qaytadan kiriting",
  new_password_repeat_placeholder: "Parolni qayta kiriting",
  passwords_not_match: "Parollar mos kelmayapti",

  // Test pages
  my_office: "Mening ofisim",
  questions_count: "Savollar soni:",
  attempts_count: "Urinishlar soni",
  previous_question: "oldingi savol",
  finish_test: "Tugatish",
  next_question: "Keyingi savol",
  retake_test: "Testni qayta topshirish",
  start: "BOSHLASH",
  intermediate_test_passed:
    "Siz {course} kursining oraliq testini muvafaqqiyotli o'ttingiz.",

  // Mobile bar
  home: "Asosiy",
  courses: "Kurslar",

  // MyCard page
  card_number_placeholder: "Karta raqami",
  card_expiry_placeholder: "Kartaning amal qilish muddati",
  sms_code_sent: "SMS tasdiqlash kodi",
  sms_code_sent_to: "{phone} raqamga yuborilgan",
  code_input_placeholder: "Kodni kiriting",
  delete_card_confirm:
    "Haqiqatan ham xaritani uzishni xohlaysizmi? Agar siz o'chirib tashlasangiz, ushbu kartani qayta ulay olmaysiz",

  // Notification
  no_new_notifications: "Sizda yangi xabarnomalar mavjud emas",

  // Certified course
  no_certificated_courses: "Sertifikatlanadigan kurslar mavjud emas!",

  // Promo codes
  code_placeholder: "Kod",

  // Lesson layout
  lessons_count_label: "TA DARS",

  // Delete course popup
  delete_course_confirm: "Siz kursni o'chirmoqchimisiz?",

  // Proktoring
  proctoring_loading: "Kuzatuv seansi tayyorlanmoqda…",
  proctoring_finished: "Kuzatuv seansi tugadi.",
  proctoring_retry: "Qayta urinish",
  proctoring_error_sdk:
    "Kuzatuv tizimini yuklab bo'lmadi. Internet aloqasini tekshiring.",
  proctoring_error_token:
    "Kuzatuv seansi tasdiqlanmadi. Sahifani yangilab, qayta urinib ko'ring.",
  proctoring_error_permissions:
    "Testni boshlash uchun kamera, mikrofon va ekranga ruxsat bering.",
  proctoring_error_generic:
    "Kuzatuv seansini boshlab bo'lmadi. Qayta urinib ko'ring.",
};
